import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prgov-dialog-cronograma',
  templateUrl: './dialog-cronograma.component.html',
  styleUrls: ['./dialog-cronograma.component.scss']
})
export class DialogCronogramaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
